import { useCallback, useEffect, useRef } from "react";

/**
 * Makes async hook effects ignore results from an earlier filter state.
 * The transport still completes, but only the most recent request may update
 * component state.
 */
export const useLatestRequestGuard = (): (() => () => boolean) => {
  const requestVersionRef = useRef(0);

  useEffect(
    () => () => {
      requestVersionRef.current += 1;
    },
    [],
  );

  return useCallback(() => {
    const requestVersion = ++requestVersionRef.current;
    return () => requestVersionRef.current === requestVersion;
  }, []);
};
